// Where a Book opens: the screen its state makes it worth opening on. Both
// the dashboard's card link and /books/:id itself answer from this map, so a
// Book cannot land in one place from the list and another from its own URL.
// The dashboard knows nothing but the state, so the map is by state alone, and
// every entry must name a step that is open in that state: the landing invariant
// in tests/client/entry-logic.test.ts checks that against stepLock for all eleven.
import type { BookState } from "@contract";

/** Route segment under /books/:id, one per Book state. */
export const BOOK_LANDING_SEGMENT: Readonly<Record<BookState, string>> = Object.freeze({
  // Parse is still running: only the Book page has anything to say.
  uploaded: "overview",
  parsed: "overview",
  // The Style Sheet pass is running and has written nothing yet, so its screen
  // is still locked; the Book page's strip is what says the pass is running.
  confirmed: "overview",
  styleSheetReady: "overview",
  // The Calibration Chapter is being refined or waits for its approval, and
  // the Style Sheet is what the Author reads while that happens. Review is one
  // step away in the nav as soon as the first Narration Script exists.
  calibrating: "overview",
  refining: "overview",
  inReview: "overview",
  approved: "overview",
  rendering: "overview",
  rendered: "overview",
  // The retry sits on the Book page, next to the job that stopped.
  failed: "overview",
});

export const bookLandingPath = (id: string, state: BookState): string =>
  `/books/${id}/${BOOK_LANDING_SEGMENT[state]}`;
